<template>
	<div>
		<v-divider class="mx-n1" style="width: calc(100% + 8px); max-width: none" />
		<div v-if="$route.path === '/medicalstaff'" class="mt-1 d-flex align-center justify-space-between">
			<div class="d-flex align-center">
				<v-text-field
					class="mr-1"
					prepend-inner-icon="mdi-magnify"
					hide-details
					dense
					v-if="getRoutes"
					v-model="search"
					:label="$t('search')"
					outlined />
				<v-select
					style="max-width: 150px"
					class="mx-1"
					hide-details
					dense
					v-model="selectedUserStatusVerifier"
					:items="medicalStaffStatusVerifiers"
					item-value="lowValue"
					item-text="shortDescription"
					:label="$t('status')"
					outlined
					:menu-props="{ offsetY: true }" />
				<v-select
					style="max-width: 150px"
					class="mx-1"
					hide-details
					:menu-props="{ offsetY: true }"
					dense
					v-model="role"
					:items="roles"
					item-value="id"
					:item-text="$i18n.locale === 'en' ? 'roleNameForDisplay' : 'roleNameForDisplayESP'"
					:label="$t('role')"
					outlined />
				<!-- <v-autocomplete
					class="ml-1"
					hide-details
					dense
					v-model="surgery"
					:item-text="$i18n.locale === 'en' ? 'longDescription' : 'longDescriptionEsp'"
					item-value="lowValue"
					:items="getSpecializations"
					:label="$t('specialization')"
					outlined /> -->
			</div>
			<div class="d-flex align-center">
				<v-btn @click="synchronizeDrawers(true)" color="chips" variant="tonal" prepend-icon="mdi-plus" class="ma-1">
					<span class="text-capitalize text-color-white">{{ $t('bulk-assign-medical-staff') }}</span>
				</v-btn>
				<v-btn @click="synchronizeDrawers" class="add-button-style ml-1">
					<span style="text-transform: capitalize" class="font-size15"> + {{ $t(pathname) }}</span>
				</v-btn>
			</div>
		</div>
		<v-row dense v-else-if="!['/dashboard'].includes($route.path)" class="mx-0 px-0">
			<v-col cols="2" class="mt-1" v-if="getRoutes">
				<v-text-field
					prepend-inner-icon="mdi-magnify"
					hide-details
					dense
					v-model="search"
					:label="$t('search')"
					outlined />
			</v-col>
			<v-col cols="2" class="mt-1" v-if="this.$route.path === '/schedules'">
				<v-text-field
					prepend-inner-icon="mdi-magnify"
					hide-details
					dense
					v-model="searchTaskList"
					:label="$t('search-task-list-items')"
					outlined />
			</v-col>
			<template v-if="$route.path === '/patients'">
				<v-col cols="1" class="mt-1">
					<v-select
						class="width-text-field2"
						hide-details
						dense
						v-model="selectedUserStatusVerifier"
						:items="userStatusVerifiers"
						item-value="lowValue"
						item-text="shortDescription"
						:label="$t('status')"
						outlined
						:menu-props="{ offsetY: true }">
					</v-select>
				</v-col>
				<v-col cols="2" class="mt-1" v-if="!(userData.isSequoiaUser === false || userData.isSequoiaUser === null)">
					<v-select
						class="width-text-field2"
						hide-details
						dense
						v-model="billingType"
						:items="billingTypes"
						item-value="lowValue"
						item-text="shortDescription"
						label="Billing Type"
						outlined
						:menu-props="{ offsetY: true }" />
				</v-col>
			</template>
			<v-col
				cols="2"
				v-if="
					$route.path === '/monthlyreview' &&
					!(this.userData.isSequoiaUser === false || this.userData.isSequoiaUser === null)
				">
				<v-select
					class="width-text-field2 mt-1"
					hide-details
					dense
					v-model="billingType"
					:items="billingTypes"
					item-value="lowValue"
					item-text="shortDescription"
					label="RPM"
					outlined
					:menu-props="{ offsetY: true }" />
			</v-col>
			<v-col cols="2" v-if="$route.path === '/licenses'">
				<v-select
					class="width-text-field2 mt-1"
					hide-details
					dense
					v-model="selectedLicensesVerifiers"
					:items="licenseStatuses"
					item-value="lowValue"
					:item-text="$i18n.locale === 'en' ? 'shortDescription' : 'shortDescriptionEsp'"
					:label="$t('licenses')"
					outlined
					:menu-props="{ offsetY: true }" />
			</v-col>
			<div
				style="display: flex; align-items: center"
				v-if="['/billings', '/monthlyreview', '/dashboardFacility', '/auditReport'].includes($route.path)"
				class="d-flex justify-end mt-2 ml-auto">
				<v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="-90" offset-y min-width="auto">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="selectedDateForBilling"
							label="Filter date"
							readonly
							v-bind="attrs"
							single-line
							hide-details
							prepend-inner-icon="mdi-calendar"
							dense
							v-on="on"
							class="mt-n1"
							outlined />
					</template>
					<v-date-picker
						v-model="selectedDateForBilling"
						color="primary"
						type="month"
						no-title
						scrollable
						@change="menu1 = false" />
				</v-menu>
				<v-btn
					@click="generateCSV"
					v-if="$route.path === '/billings'"
					color="chips"
					variant="tonal"
					class="ml-2 float-right"
					style="text-transform: capitalize; color: white"
					prepend-icon="mdi-plus">
					<v-icon class="mdi mdi-cloud-download mdi-18px mt-1" />
				</v-btn>
			</div>
			<div style="display: flex; align-items: center" v-if="$route.path === '/dailyreports'" class="ml-auto mr-2">
				<v-menu v-model="menu1" :close-on-content-click="false" offset-y nudge-right="-25" min-width="auto">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="selectedDateForReports"
							label="Filter date"
							readonly
							v-bind="attrs"
							single-line
							hide-details
							prepend-inner-icon="mdi-calendar"
							dense
							v-on="on"
							class="mr-5 mt-1 mb-n1"
							outlined />
					</template>
					<v-date-picker
						v-model="selectedDateForReports"
						color="primary"
						type="date"
						no-title
						scrollable
						@change="menu1 = false" />
				</v-menu>
			</div>
			<div v-if="$route.path === '/medicalNotesCategory'" class="d-flex align-center justify-end ml-auto mt-1">
				<v-btn @click="synchronizeDrawers" class="add-button-style ma-1 mb-0">
					<span style="text-transform: capitalize" class="font-size15"> + {{ $t(pathname) }}</span>
				</v-btn>
			</div>

			<v-col v-if="$route.path === '/residentMappingPcc'" class="d-flex align-center justify-end py-1"> </v-col>

			<v-col
				v-if="
					$route.path !== '/billings' &&
					$route.path !== '/licenses' &&
					$route.path !== '/dailyreports' &&
					$route.path !== '/monthlyreview' &&
					$route.path !== '/dashboardFacility' &&
					$route.path !== '/residentMapping' &&
					$route.path !== '/medicalStaffMapping' &&
					$route.path !== '/organizationMapping' &&
					$route.path !== '/locationMapping' &&
					$route.path !== '/medicalNotesCategory' &&
					$route.path !== '/residentMappingPcc' &&
					$route.path !== '/offices' &&
					$route.path !== '/auditReport'
				"
				class="d-flex align-center justify-end py-1">
				<v-btn @click="synchronizeDrawers" class="add-button-style ma-1">
					<span style="text-transform: capitalize" class="font-size15"> + {{ $t(pathname) }}</span>
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { addWhite } from '@/assets';

export default {
	data: () => ({
		addWhite: addWhite,
		search: null,
		searchTaskList: null,
		role: -99,
		selectedDateForBilling: new Date().toISOString().substr(0, 7),
		selectedDateForReports: new Date().toISOString().substr(0, 10),
		medical: null,
		menu1: false,
		selectedUserStatusVerifier: -99,
		surgery: -1,
		selectedMedicalInstitution: -1,
		selectedMedicalStaffStatus: -99,
		selectedLicensesVerifiers: null,
		showWizard: false,
	}),
	computed: {
		...mapState({
			userData: (state) => state.authentication.userData,
			allVerifiers: (state) => state.verifiers.allverifires,
			hospitals: (state) => state.hospitals.hospitals,
		}),
		...mapGetters({
			roles: 'roles/getRoles',
			getSpecializations: 'verifiers/getSpecializations',
			medicalInstitutions: 'medicalInstitutions/getMedicalInstitutionsSorted',
			getMedicalTeam: 'filterbar/getMedicalTeam',
			appBarUserStatusVerifier: 'filterbar/getUserStatusVerifier',
			roleName: 'authentication/getRole',
			appBarBillingTypeFilterVerifier: 'filterbar/getRpmValue',
		}),
		getRoutes () {
			const allowedRoutes = [
				'/medicalstaff',
				'/patients',
				'/wellnessassessments',
				'/billings',
				'/mentalhealthpatient',
				'/medicalNotesCategory',
				'/UserBillingSettings',
				'/billingsettings',
				'/monthlyreview',
				'/medicalteam',
				'/licenses',
				'/tablets',
				'/schedules',
				'/offices',
				'/auditReport',
			];
			return allowedRoutes.includes(this.$route.path);
		},
		pathname () {
			return this.$route.name;
		},
		drawer: {
			get () {
				return this.$store.state.drawer;
			},
			set (val) {
				this.$store.commit('SET_DETAILS_DRAWER', val);
			},
		},
		billingType: {
			get () {
				return this.appBarBillingTypeFilterVerifier || 0;
			},
			set (value) {
				this.$store.dispatch('filterbar/AppBarRpmFilterVerifier', value);
			},
		},
		detailsDrawer () {
			return this.$store.state.detailsDrawer;
		},
		userStatusVerifiers () {
			let userStatusVerifiersList =
				this.allVerifiers != null ? this.allVerifiers.filter((v) => v.rvDomain === 'USER_STATUS') : null;
			if (userStatusVerifiersList != null) {
				userStatusVerifiersList.unshift({ lowValue: -99, shortDescription: 'All', shortDescriptionESP: 'Todo' });
			} else {
				userStatusVerifiersList = [];
				userStatusVerifiersList.unshift({ lowValue: -99, shortDescription: 'All', shortDescriptionESP: 'Todo' });
			}
			return userStatusVerifiersList;
		},
		billingTypes () {
			return this.allVerifiers?.filter((v) => v.rvDomain === 'BILLING_TYPE_FILTER') ?? null;
		},
		billingTypesWithoutRTM () {
			// Create a copy of the filtered items and modify the copy, leaving the original untouched
			return this.allVerifiers != null
				? this.allVerifiers
						.filter((v) => v.rvDomain === 'BILLING_TYPE_FILTER') // Filter by rvDomain
						.map((v) => {
							// Create a copy of the current item to modify it
							const modifiedItem = { ...v };

							// Apply the changes to the copy
							if (modifiedItem.lowValue === 0) {
								modifiedItem.shortDescription = 'RPM Patients';
								modifiedItem.longDescription = 'RPM Patients';
								modifiedItem.shortDescriptionEsp = 'Pacientes RPM';
								modifiedItem.longDescriptionEsp = 'Pacientes RPM';
							}

							return modifiedItem; // Return the modified copy
						})
				: null;
		},
		medicalStaffStatusVerifiers () {
			let userStatusVerifiersList =
				this.allVerifiers != null ? this.allVerifiers.filter((v) => v.rvDomain === 'USER_STATUS') : null;
			if (userStatusVerifiersList != null) {
				userStatusVerifiersList = userStatusVerifiersList.filter((v) => v.lowValue !== 10 && v.lowValue !== 99);
				userStatusVerifiersList.unshift({ lowValue: -99, shortDescription: 'All', shortDescriptionESP: 'Todo' });
			} else {
				userStatusVerifiersList = [];
				userStatusVerifiersList.unshift({ lowValue: -99, shortDescription: 'All', shortDescriptionESP: 'Todo' });
			}
			return userStatusVerifiersList;
		},
		licenseStatuses () {
			return [
				{ lowValue: null, shortDescription: 'All', shortDescriptionEsp: 'Todo' },
				{ lowValue: true, shortDescription: 'Active', shortDescriptionEsp: 'Activo' },
				{ lowValue: false, shortDescription: 'Inactive', shortDescriptionEsp: 'Inactivo' },
			];
		},
	},
	async mounted () {
		if (this.roleName !== 'PARTNER') {
			await this.getAllVerifiers();
		}
		await this.$store.dispatch('filterbar/AppBarUserStatusVerifier', 3);
		await this.$store.dispatch('filterbar/AppBarDate', this.getCurrentMonthAndYear());
	},
	methods: {
		getCurrentMonthAndYear () {
			const currentDate = new Date();
			const year = currentDate.getFullYear();
			const month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
			return `${year}-${month}`;
		},
		async getAllVerifiers () {
			// we call this API endpoint only if the store values are null
			if (this.allVerifiers == null) {
				await this.$store.dispatch('verifiers/getAllVerifiers').then(() => {
					// this.loading = false;
				});
			}
		},
		...mapMutations({
			setDrawer: 'SET_DETAILS_DRAWER',
		}),
		synchronizeDrawers (iBulkAssign = false) {
			var parameters = {};
			if (iBulkAssign === true) {
				parameters = {
					detailsDrawer: true,
					page: 'medicalStaffAssign',
				};
				this.$store.commit('SET_DETAILS_DRAWER', parameters);
				return;
			}

			switch (this.pathname.toLowerCase()) {
				default:
					parameters = {
						detailsDrawer: true,
						page: this.pathname.toLowerCase(),
					};
					this.$store.commit('SET_DETAILS_DRAWER', parameters);
					break;
			}
		},
		async generateCSV () {
			const data = { organizationId: this.userData.organizationId };
			await this.$store.dispatch('filterbar/generateCSV', data);
		},
	},
	watch: {
		$route (to, from) {
			if (to.path !== from.path) {
				this.search = null;
				this.selectedUserStatusVerifier = -99;
			}
			if (to.path !== '/dailyreports') {
				this.selectedDateForReports = new Date().toISOString().substr(0, 10);
			}
			if (to.path !== '/billings') {
				this.selectedDateForBilling = new Date().toISOString().substr(0, 7);
			}
			if (to.path !== '/monthlyreview') {
				this.selectedDateForBilling = new Date().toISOString().substr(0, 7);
			}
		},

		async selectedUserStatusVerifier (val) {
			await this.$store.dispatch('filterbar/AppBarUserStatusVerifier', val);
		},
		async billingType (val) {
			await this.$store.dispatch('filterbar/AppBarRpmFilterVerifier', val);
		},
		async selectedMedicalStaffStatus (val) {
			await this.$store.dispatch('filterbar/AppBarMedicalStaffStatus', val);
		},
		async surgery (val) {
			await this.$store.dispatch('filterbar/AppBarSpacialization', val);
		},
		async role (val) {
			await this.$store.dispatch('filterbar/AppBarRole', val);
		},
		async search (val) {
			await this.$store.dispatch('filterbar/AppBarSearch', val);
		},
		async searchTaskList (val) {
			await this.$store.dispatch('filterbar/AppBarSearchTaskList', val);
		},
		async selectedMedicalInstitution (val) {
			await this.$store.dispatch('filterbar/AppBarMedicalInstitution', val);
		},
		async selectedDateForBilling (val) {
			await this.$store.dispatch('filterbar/AppBarDate', val);
		},
		async selectedDateForReports (val) {
			await this.$store.dispatch('filterbar/AppBarDate', val);
		},
		async selectedLicensesVerifiers (val) {
			await this.$store.dispatch('filterbar/AppBarLicenseStatusVerifier', val);
		},
	},
};
</script>
